import dayjs from "dayjs";
import { apiRequest } from "../../../infrastructure/backendService";
import { CommonButton, CommonOutlinedButton } from "../../common/StyledComponents/StyledFields";
import { ClipLoader } from "react-spinners";
import { useState } from "react";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";

const AnnualAbhisekhamReport = ({ sendDataToParent, getReportData }:any) => {
  const [loading, setLoading] = useState(false);

    const handleAnnualAbhisekhamReport = async () => {
        const endDate = dayjs().subtract(1, 'month').endOf('month').format("MM/DD/YYYY");
        const startDate = dayjs().subtract(12, 'month').startOf('month').format("MM/DD/YYYY");
        let reqBody: any = {};
        reqBody.deityName = "ALL";
        reqBody.poojaId = 77;
        reqBody.fromDate = startDate;
        reqBody.toDate = endDate;
        setLoading(true);
        apiRequest({
            method: "POST",
            endpoint: '/report-dashboard/reports/abhishekam/ANNUAL_ABHISHEKA_REPORT/browser',
            body: JSON.stringify(reqBody),
            includeToken:true
          })
          .then((res) => {
            setLoading(false);
            sendDataToParent(true,reqBody);
            const response = res.data.map((report:any)=>{
              return {
                ...report,
                userinfo:report.userinfo.map((userInfo:any)=>{
                  return {
                    username:userInfo.username,
                    gothram:userInfo.gothram,
                    nakshtram:userInfo.nakshtram,
                    ...userInfo,
                  }
                })
              }
            })
            // getReportData(res.data);
            getReportData(response);
          })
          .catch((err) => {
            setLoading(false);
          })
    }
    
    return (
      <CommonOutlinedButton
        sx={{ width: "fit-content", height: "38px" }}
        onClick={handleAnnualAbhisekhamReport}
        disabled={loading}
        id="submit"
      >
        <ButtonLoader isBtnLoading={loading} btnText={"Annual Abhishekam Report"} />
      </CommonOutlinedButton>
    );
}
export default AnnualAbhisekhamReport;